import { CommonModule } from '@angular/common';
import { ErrorHandler, NgModule } from '@angular/core';

import { NewRelicAppMetaDirective } from './new-relic-app-meta.directive';
import { NewRelicErrorHandlerService } from './new-relic-error-handler.service';
import { NewRelicUserMetaDirective } from './new-relic-user-meta.directive';
import { INewRelicConfig, NewRelicConfig } from './new-relic.config';

@NgModule({
  imports: [CommonModule],
  declarations: [NewRelicAppMetaDirective, NewRelicUserMetaDirective],
  exports: [NewRelicAppMetaDirective, NewRelicUserMetaDirective],
})
export class NewRelicModule {
  static forRoot(config: INewRelicConfig) {
    return {
      ngModule: NewRelicModule,
      providers: [
        {
          provide: NewRelicConfig,
          useValue: config,
        },
        {
          provide: ErrorHandler,
          useClass: NewRelicErrorHandlerService,
        },
      ],
    };
  }
}
